document.addEventListener("DOMContentLoaded", function() {

    const productFieldsets = document.querySelectorAll('.product-form__input:first-of-type');

  updateCustomPutterMediaOnLoad();

    productFieldsets.forEach(fieldset => {
        fieldset.addEventListener('change', function() {
            updateCustomPutterMedia(fieldset);
        });
    });

  function updateCustomPutterMedia(fieldset){
    const selectedInput = fieldset.querySelector('input[type="radio"]:checked');
            if (selectedInput) {
                const selectedValue = selectedInput.value.trim().toLowerCase();
                const thumbnails = document.querySelectorAll('.product-image');

                thumbnails.forEach(thumbnail => {
                  const image = thumbnail.querySelector('.product-image img');
                    const altText = image.getAttribute('alt');
                    
                    if (altText != product_title) {
                        if (altText.trim().toLowerCase() === selectedValue) {
                            thumbnail.style.display = 'block';
                        } else {
                            thumbnail.style.display = 'none';
                        }
                    } else {
                     thumbnail.style.display = 'block'; 
                    }
                });
            }
  }


   function updateCustomPutterMediaOnLoad(){

    const selectedInput = document.querySelector('.product-form__input:first-of-type input[type="radio"]:checked');
            if (selectedInput) {
                const selectedValue = selectedInput.value.trim().toLowerCase();
                 const thumbnails = document.querySelectorAll('.product-image');

                thumbnails.forEach(thumbnail => {
                  const image = thumbnail.querySelector('.product-image img');
                    const altText = image.getAttribute('alt');
                    
                    if (altText != product_title) {
                        if (altText.trim().toLowerCase() === selectedValue) {
                            thumbnail.style.display = 'block';
                         
                        } else {
                            thumbnail.style.display = 'none';
                        }
                    } else {
                     thumbnail.style.display = 'block'; 
                    }
                });
            }
  }
});


$(document).ready(function() {
    var selectedVariantText;
    
    // When a .product-form__input label element gets clicked
    $('.product-form__input label').click(function() {
        // Get the ID of the input element associated with this label
        var inputId = $(this).attr('for');
        
        // Find the input element with the corresponding ID and get its value
        var selectedVariantText = $('#' + inputId).val().trim().toLowerCase().replace(/suzuka (x|y|i)/g, "suzuka");
  
        // Loop through elements with a class of .collection-tab-button
        $('.collection-tab-button').each(function() {
            // Get the text of the current element, strip extra spaces, and convert to lowercase
            var buttonText = $(this).text().trim().toLowerCase();
           
            // If the inner text of one of these elements contains selectedVariantText
            if (buttonText.indexOf(selectedVariantText) !== -1) {
                // Force a click of that element
                $(this).click();
            }
        });
    });

   
});

/*
/////javascript for thumbnail image layout

document.addEventListener("DOMContentLoaded", function() {

    const productFieldsets = document.querySelectorAll('.product-form__input');

  updateCustomPutterMediaOnLoad();

    productFieldsets.forEach(fieldset => {
        fieldset.addEventListener('change', function() {
          setTimeout(function() { 
        updateCustomPutterMedia(fieldset);
    }, 400);
            
        });
    });

  function updateCustomPutterMedia(fieldset){
    const selectedInput = fieldset.querySelector('input[type="radio"]:checked');
            if (selectedInput) {
                const selectedValue = selectedInput.value.trim().toLowerCase();
                const thumbnails = document.querySelectorAll('.product-image');

                thumbnails.forEach(thumbnail => {
                  const image = thumbnail.querySelector('.product-image img');
                    const altText = image.getAttribute('alt');
                    
                    if (altText != product_title) {
                        if (altText.trim().toLowerCase() === selectedValue) {
                            if (thumbnail.parentNode.classList.contains("slider--tablet-up") && window.innerWidth > 767 || thumbnail.classList.contains("is-active")){
                            thumbnail.style.display = 'block';
                          } else if (!thumbnail.parentNode.classList.contains("slider--tablet-up") && window.innerWidth < 767) {
                            thumbnail.style.display = 'block';  
                          }
                        } else {
                            thumbnail.style.display = 'none';
                        }
                    } else {
                     thumbnail.style.display = 'block'; 
                    }
                });
            }
  }


   function updateCustomPutterMediaOnLoad(){

    const selectedInput = document.querySelector('.product-form__input:first-of-type input[type="radio"]:checked');
            if (selectedInput) {
                const selectedValue = selectedInput.value.trim().toLowerCase();
                 const thumbnails = document.querySelectorAll('.product-image');

                thumbnails.forEach(thumbnail => {
                  const image = thumbnail.querySelector('.product-image img');
                    const altText = image.getAttribute('alt');
                    
                    if (altText != product_title) {
                        if (altText.trim().toLowerCase() === selectedValue) {
                           if (thumbnail.parentNode.classList.contains("slider--tablet-up") && window.innerWidth > 767){
                            thumbnail.style.display = 'block';
                          } else if (!thumbnail.parentNode.classList.contains("slider--tablet-up") && window.innerWidth < 767) {
                            thumbnail.style.display = 'block';  
                          }
                            
                        } else {
                            thumbnail.style.display = 'none';
                        }
                    } else {
                     thumbnail.style.display = 'block'; 
                    }
                });
            }
  }
});


$(document).ready(function() {
    var selectedVariantText;
    
    // When a .product-form__input label element gets clicked
    $('.product-form__input label').click(function() {
        // Get the ID of the input element associated with this label
        var inputId = $(this).attr('for');
        
        // Find the input element with the corresponding ID and get its value
        var selectedVariantText = $('#' + inputId).val().trim().toLowerCase();
        console.log(selectedVariantText);
        // Loop through elements with a class of .collection-tab-button
        $('.collection-tab-button').each(function() {
            // Get the text of the current element, strip extra spaces, and convert to lowercase
            var buttonText = $(this).text().trim().toLowerCase();
            
            // If the inner text of one of these elements contains selectedVariantText
            if (buttonText.indexOf(selectedVariantText) !== -1) {
                // Force a click of that element
                $(this).click();
            }
        });
    });
});
*/
